import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

type Props = {
  columns?: number;
  cardsPerColumn?: number;
};

export default function KanbanCardsSkeleton({ columns = 5, cardsPerColumn = 3 }: Props) {
  return (
    <SkeletonTheme baseColor="#eef2f7" highlightColor="#f7f9fc">
      <div style={{ backgroundColor: "#F8FAFC", padding: 48, paddingTop: 20 }}>
        <Skeleton width={200} height={18} borderRadius={999} />
        <Skeleton width={90} height={18} borderRadius={999} />

        <div className="flex gap-4" style={{ marginTop: 24 }}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <div key={colIdx} className="bg-white border rounded-xl shadow-sm" style={{ minWidth: 340, width: 370 }}>
              <div className="px-4 py-3 border-b flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Skeleton circle width={8} height={8} />
                  <Skeleton width={140} height={18} borderRadius={999} />
                  <Skeleton width={28} height={18} borderRadius={999} />
                </div>
                <Skeleton width={18} height={18} borderRadius={6} />
              </div>

              <div className="p-3 space-y-3">
                {Array.from({ length: cardsPerColumn }).map((_, cardIdx) => (
                  <div key={cardIdx} className="border rounded-xl p-3 shadow-sm">
                    <Skeleton width="85%" height={18} borderRadius={8} />
                    <Skeleton width="60%" height={18} borderRadius={8} style={{ marginTop: 8 }} />

                    <div className="flex items-center gap-2 mt-3">
                      <Skeleton width={70} height={22} borderRadius={999} />
                      <Skeleton width={80} height={22} borderRadius={999} />
                    </div>

                    <div className="flex items-center gap-2 mt-3">
                      <Skeleton width={70} height={14} borderRadius={6} />
                      <Skeleton width={60} height={22} borderRadius={999} />
                      <Skeleton width={55} height={22} borderRadius={999} />
                    </div>

                    <div className="flex items-center justify-between mt-4">
                      <div className="flex items-center gap-2">
                        <Skeleton circle width={26} height={26} />
                        <Skeleton width={110} height={14} borderRadius={6} />
                      </div>
                      <div className="flex items-center gap-3">
                        <Skeleton width={20} height={20} borderRadius={6} />
                        <Skeleton width={20} height={20} borderRadius={6} />
                        <Skeleton width={20} height={20} borderRadius={6} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  );
}
